import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import BottomMenu from "../../layout/bottomMenu";
import NotFoundData from "../../../Images/no-data-found.webp";
import *  as Constants from '../contants';

const ReferralsGiven = ({
    getAllReferrals,
    referralList=[]
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [userId, setUserId] = useState('')
    const [pageNo, setPage] = useState(1)
    const [list,setList]=useState([]);
    const [filterInputList, setFilterInputList] = useState({})
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [open, setOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('')
    const [isGlobalSearch, setIsGlobalSearch] = useState(false)
    const [teamIds,setTeamIds]=useState([]);

    useEffect(() => {
        let userId = localStorage.getItem('user_id')
        let userProfile = JSON.parse(localStorage.getItem('user_profile'));
        if (userProfile && userProfile?.teams) {
            setTeamIds(userProfile?.teams?.map(team => team.team_id));
        }
        setUserId(userId)
    }, [userId])

    const onPageChange = async (val) => {
        setIsLoading(true);
        setPage(val?.selected + 1);
        window.localStorage.referralGivenPage=val?.selected + 1
        if(teamIds && teamIds.length > 0){
            await getAllReferrals(val?.selected + 1,{'referred_by_team_ids':teamIds});
        }
        setIsLoading(false);
    };

    useEffect(() => {
        const fetchReferrals = async () => {
            setIsLoading(true);
            let filter = window.localStorage.referralFilter ? JSON.parse(window.localStorage.referralFilter) : [{'status':1}];
            let currPage = window.localStorage.referralGivenPage ? window.localStorage.referralGivenPage : 1;
            setPage(currPage)           
            if(teamIds && teamIds.length > 0){
                setFilterInputList(filter)
                const res = await getAllReferrals(currPage,{'referred_by_team_ids':teamIds},filter,searchValue);
                setList(res);
            }
            setIsLoading(false);
        };
    
        fetchReferrals();
    }, [pageNo,getAllReferrals,userId]);
    
    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        setIsLoading(true)
        if(teamIds && teamIds.length > 0){
            const res = await getAllReferrals(pageNo, {'referred_by_team_ids':teamIds},filterInputList,searchValue);
            setList(res);
        }
        setIsLoading(false)
    }
    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.referralFilter = JSON.stringify(filterInputList)
        window.localStorage.referralGivenPage=pageNo
        if(teamIds && teamIds.length > 0){
            const res = await getAllReferrals(pageNo, {'referred_by_team_ids':teamIds},filterInputList,searchValue);
            setList(res);
        }
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {
        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            if(filterInputList[0].length === 0){
                delete window.localStorage.referralFilter
            } else {
                window.localStorage.referralFilter = JSON.stringify(filterInputList)
            }
            if(teamIds && teamIds.length > 0){
                const res = await getAllReferrals(pageNo, {'referred_by_team_ids':teamIds})
                setList(res);
            }
            setIsLoading(false)
        }
    }

    return (
        <>
          <Loader isLoading={isLoading} />
          <div id="wrapper">
            <DashboardMenu />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Header title={'Drop a new Referral'} />
                <div className="container-fluid common-bg">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                        <h1 className="h3 mb-0 text-black-100">Referrals Given by my Department</h1>
                    </div>
                    <div className="container-fluid bootstrap snippets bg-white py-4 mt-50px" style={{marginTop: 'auto'}}>
                    <form className="form-inline mr-auto navbar-search" style={{width: "100%"}}>
                        <div className="d-flex w-100">
                            <input
                                type="text"
                                className="form-control bg-light border-0 small list-filter"
                                placeholder={"Search Client Name"}
                                aria-label="Search"
                                aria-describedby="basic-addon2"
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <div className="btn-search ml-2">
                                <button
                                    className="btn btn-primary lh-32 border-left-tr-tb"
                                    type="button"
                                    onClick={() => handleSearch()}
                                >
                                    <i className="fas fa-search fa-sm"></i>
                                </button>
                            </div>
                            <div className="ml-10">
                                <button
                                    onClick={() => setOpen(!open)}
                                    className="btn btn-sm btn-primary btn-filter mt-1"
                                    type="button"
                                >
                                    <i className="fa fa-filter lh-35 pd-3"></i>
                                </button>
                            </div>
                        </div>
                            
                    </form>
                    {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                    <div className="row pd-filter-div">
                                        <div className="col-md-12 col-sm-12 d-flex">
                                            <div className="applied-filter">
                                                {Object.keys(filterInputList[0]).map((val, i) => {
                                                    return (
                                                        <>
                                                        
                                                        <span className="fd-1">
                                                            <span style={{textTransform: "capitalize"}}>
                                                                {val.replaceAll("_", " ")}
                                                            </span>
                                                            {" - " + Constants.referalFilterArray.filter((filter) => filter.id==filterInputList[0][val])?.[0]?.name}
                                                            <i className="bi bi-x-circle" onClick={(e) => {
                                                                handleRemoveFilter(val)
                                                            }}></i></span>
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        <div className="row">
                        {list?.data && list?.data.map((referral, index) => (
                            <div className="col-md-4 col-sm-6 mb-4" key={index}>
                                <div className="card-big-shadow">
                                    <div className="card card-just-text" style={{width: "100%"}}>
                                        <div className="content">
                                            <h6 className="category mrg-b-12">
                                                <div className={`header-ui-item-opp bg-${referral?.status_colour_class} text-white`}>
                                                    {referral?.status_text}
                                                </div>
                                            </h6>
                                            <div className="row list-view">
                                                {[
                                                    { icon: "fa-calendar-alt", label: "Date of Referral", value: referral?.created_at ? new Date(referral.created_at).toISOString().split('T')[0] : '' },
                                                    { icon: "fa-building", label: "Referral for Department", value: referral?.project_type || 'N/A', truncate: true },
                                                    { icon: "fa-user", label: "Referral By Name", value: referral?.referred_by_name || 'N/A' },
                                                    { icon: "fa-phone-alt", label: "Referral By Number", value: referral.referred_by_contact || 'N/A' },
                                                    { icon: "fa-envelope", label: "Referral By Mail", value: referral.referred_by_email || 'N/A' },
                                                    { icon: "fa-user", label: "Client Name", value: referral.client_name },
                                                    { icon: "fa-map-marker-alt", label: "Location", value: referral.city },
                                                    { icon: "fa-user", label: "Program Manager Remarks", value: referral.remarks ? referral.remarks : 'N/A' },
                                                    { icon: "fa-info-circle", label: "Lead ID/Account ID", value: referral.merged_id ? referral.merged_id : 'N/A' }
                                                ].map((item, i) => (
                                                    <div className="mb-flex d-flex justify-content-between align-items-start w-100" key={i}>
                                                        <div className="col-md-6 col-sm-6 no-wrap d-flex align-items-center">
                                                            <i className={`fas ${item.icon} text-primary mr-2`}></i>
                                                            <span style={{fontSize:"0.85rem"}}>{item.label}</span>
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2 text-right">
                                                            <span style={{fontSize:"0.85rem"}}>{item.value.length > 20 ? `${item.value.substring(0, 20)}...` : item.value}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                                     
                                            </div>
                                                <div className="d-flex" style={{justifyContent: 'center'}}>
                                                    <button 
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                            window.localStorage.referralGivenPage=pageNo
                                                            window.location.href = `referrals-view/${referral.id}`
                                                            }
                                                        }
                                                    >
                                                        View details
                                                    </button>
                                                </div>    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

            {list?.data && list?.data.length > 0 && (
                <div className="panel-pagination-col panel-table-pagination">
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={Math.ceil(list?.total / list?.per_page)}
                        forcePage={pageNo - 1}
                        pageRangeDisplayed={4}
                        onPageChange={onPageChange}
                        activeClassName={'active'}
                    />
                </div>
            )}
            {list?.data && list?.data.length === 0 && (
                <>
                    <img src={NotFoundData} className="not-found-data" alt="Not Found" />
                    <div className="text-center" style={{ width: "100%" }}>
                        Data Not Found
                    </div>
                </>
            )}
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={
                        {data:
                            [
                                {
                                    'field' : 'dropdown', 
                                    'place_holder' : 'Status', 
                                    'values' : Constants.referalFilterArray
                                }
                            ]
                        }
                    }
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
          </div>
        </>
      );
};

export default ReferralsGiven;